import { render, staticRenderFns } from "./page03.vue?vue&type=template&id=60ec7f26&scoped=true&"
import script from "./page03.vue?vue&type=script&lang=js&"
export * from "./page03.vue?vue&type=script&lang=js&"
import style0 from "./page03.vue?vue&type=style&index=0&id=60ec7f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ec7f26",
  null
  
)

export default component.exports